/**
 * Web App Constants
 *
 * Named constants for values previously used as magic numbers.
 */

// ============================================================================
// Time Intervals & Durations (milliseconds)
// ============================================================================

export const QUERY_STALE_TIME_MS = 60_000; // 1 minute
export const MAX_RETRY_DELAY_MS = 30_000; // 30 seconds
export const TOOLTIP_DELAY_MS = 300;
export const TOAST_DURATION_MS = 3_000; // 3 seconds
export const TOAST_LONG_DURATION_MS = 5_000; // 5 seconds
export const TOKEN_REFRESH_INTERVAL_MS = 50_000; // 50s (10s before 60s expiry)
export const IDEMPOTENCY_WINDOW_MS = 60_000; // 1 minute
export const BATCH_REFETCH_INTERVAL_MS = 10_000; // 10 seconds
export const CREDIT_POLL_INTERVAL_MS = 10_000; // 10 seconds
export const FILE_UPLOAD_TIMEOUT_MS = 120_000; // 2 minutes
export const REFRESH_DELAY_MS = 500; // Delay after server operations
export const SEARCH_DEBOUNCE_MS = 300;
export const COPY_FEEDBACK_DURATION_MS = 2_000; // 2 seconds

// ============================================================================
// Pagination Limits
// ============================================================================

export const DEFAULT_DESIGNS_PER_PAGE = 12;
export const DEFAULT_TASKS_PER_PAGE = 20;
export const DEFAULT_BATCHES_PER_PAGE = 10;
export const TRANSACTIONS_PER_PAGE = 10;
export const ACTIVE_TASKS_FETCH_LIMIT = 50;
export const DIALOG_LIST_LIMIT = 50;
export const MAX_DESIGNS_FOR_DROPDOWN = 100;

// ============================================================================
// Utility Constants
// ============================================================================

export const MS_PER_MINUTE = 60_000;
export const MINUTES_PER_HOUR = 60;
export const HOURS_PER_DAY = 24;
export const BYTES_PER_KB = 1024;
export const BYTES_PER_MB = 1024 * 1024;
